import React, { useContext } from 'react'

import { MetricsContext } from '../../context'
import { Card, CardHeading, CardContent } from '../../../../components/layout/Card'
import { buildProjectionDatasets } from './data'
import { Projection } from '../../../../components/Projection'

export const GroupProjection = ({ usePresentValue }) => {
  const { state } = useContext(MetricsContext)
  const { groupCapitalGrowthChartData, groupInflation, colors, groupName } = state
  const { age, retirement_age, expected_age, actual_data, required_data } = groupCapitalGrowthChartData
  const ageData = {
    currentAge: age,
    retirementAge: retirement_age,
    expectedAge: expected_age
  }

  const datasets = buildProjectionDatasets(actual_data, required_data, colors, ageData, usePresentValue, groupInflation / 100)
  return (
    <Card className='metrics-dashboard__projection'>
      <CardHeading>
        <h5>{groupName} group projection</h5>
      </CardHeading>
      <CardContent>
        <Projection
          datasets={datasets}
          colors={colors}
        />
      </CardContent>
    </Card>
  )
}
